import { isIosDevice } from './platform.utils';

/**
 * Копирует File в memory-backed Blob (только iOS).
 * Нужен для iOS Safari: исходный File из input после async (FileReader и т.п.)
 * может стать нечитаемым → XHR шлёт multipart с Content-Length: 0.
 * На остальных платформах возвращает исходный File без копирования.
 */
export async function cloneFile(file: File): Promise<File> {
  if (!isIosDevice()) {
    return file;
  }

  if (!file || file.size === 0) {
    throw new Error('Empty file cannot be uploaded');
  }

  const buffer = await file.arrayBuffer();
  if (!buffer.byteLength) {
    throw new Error('Empty file cannot be uploaded');
  }

  return new File([buffer], file.name, {
    type: file.type || 'application/octet-stream',
    lastModified: file.lastModified,
  });
}
